import { keepPreviousData, useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { getRefunds } from '../refundsEndpoints'
import { refundKeys } from '../refundsQueryKeys'
import type { GetRefundsParams } from '../../types/refundsTypes'

const DEFAULT_PAGE = 1
const DEFAULT_LIMIT = 10

export function useRefundsListQuery(filters: MaybeRefOrGetter<Partial<GetRefundsParams>>) {
  return useQuery({
    queryKey: () => refundKeys.list(toValue(filters)),
    queryFn: () =>
      getRefunds({
        page: DEFAULT_PAGE,
        limit: DEFAULT_LIMIT,
        ...toValue(filters),
      }),
    placeholderData: keepPreviousData,
  })
}
